import AddUserStep from "../AddUserStep";
import { BillingPage } from "../BillingPage";
import { CrmIntegrationStep } from "../CrmIntegrationStep";
import { withStep } from "../OnboardingStepsProvider";
import { ProfileInfoStep } from "../ProfileInfoStep";

export const Step = {
  Profile: withStep(ProfileInfoStep),
  Subscription: withStep(BillingPage),
  CRMIntegration: withStep(CrmIntegrationStep),
  AddUserStep: withStep(AddUserStep),
};

export default Step;
